import { PlanType } from 'logic/subscription/plan/types'
import { planSpecs } from 'logic/subscription/plan/spec'
import { describePlanGroup } from 'logic/subscription/group/describe'

export function describePlan(planType: PlanType) {
  return {
    planGroup: () => describePlanGroup(planSpecs[planType].planGroup),
  }
}
